// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sqmB","question":"styles_question__-BTVp","description":"styles_description__23TuE"};